<div id="left-sidebar" class="sidebar">
  <div class="sidebar-scroll">
    <div class="user-account">
      <img src="../assets/images/user.png" class="rounded-circle user-photo" alt="Profile Picture">
      <div class="dropdown">
        <span>Hello,</span>
        <a href="javascript:void(0);" class="dropdown-toggle user-name" data-toggle="dropdown"><strong>{{ currentUser.full_name || "User" }}</strong></a>
        <ul class="dropdown-menu dropdown-menu-right account">
          <li ><a (click)="goToUserProfile()"><i class="icon-user"></i>My Profile</a></li>
          <!--<li  *ngIf="checkPrivilege(['agent', 'super_agent'])" ><a href="javascript:void(0);" [routerLink]="['/change-password']"><i class="icon-settings"></i>Change Password</a></li>-->
          <li  *ngIf="checkPrivilege(['agent', 'super_agent'])" ><a href="javascript:void(0);" (click)="goToSettings()" ><i class="icon-settings"></i>Settings</a></li>
          <li class="divider"></li>
          <li><a (click)="logOut()"><i class="icon-power"></i>Logout</a></li>
        </ul>
      </div>
      <hr>
      <!-- <ul class="row list-unstyled"  *ngIf="checkPrivilege(['agent', 'super_agent'])" >
        <li class="col-12">
          <h5>Wallet<span class="ml-2" style="font-size: 14px;">{{ wallet || 0 | currency: '&#8358;' }}</span></h5>

        </li>
      </ul> -->
    </div>
    <!-- virtual account details -->
     <div class="d-flex flex-column align-items-start g-2 p-2 position-absolute w-100 " style="bottom: 0;" *ngIf="checkPrivilege(['agent'])">
      <h6 class="font-weight-bold"><strong>Virtual Account: </strong></h6>
      <div class="d-flex justify-content-between align-items-center w-100">
        <strong class="d-block">{{riderVirtualBankDetails.van_account_number}}</strong>
        <small class="d-block">{{riderVirtualBankDetails.van_bank}}</small>
      </div>
      <div class="d-flex justify-content-between align-items-center w-100">
        <strong class="d-block">{{riderVirtualBankDetails.operator_category | titlecase}}</strong>
        <small class="d-block">{{riderVirtualBankDetails.van_type}}</small>
      </div>
     </div>
    <!-- Nav tabs -->
    <!-- <ul class="nav nav-tabs text-center">
      <li class="nav-item"><a class="nav-link active" data-toggle="tab" href="#main-menu-tab">Menu</a></li>
      <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#WalletSystem" *ngIf="checkPrivilege(['agent', 'super_agent'])" >Wallet</a></li>
      <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#setting" *ngIf="checkPrivilege(['super_agent'])" ><i class="icon-settings"></i></a></li>

    </ul> -->

    <!-- Tab panes -->
    <div class="tab-content p-l-0 p-r-0 d-flex flex-column justify-content-between">
      <div class="tab-pane active" id="main-menu-tab">
        <nav id="left-sidebar-nav" class="sidebar-nav">
          <ul id="main-menu" class="metismenu">
            <li class="navLinks nav-link-special"  id="dashboard" routerLinkActive="active">
              <a [routerLink]="['/user/dashboard']"><i class="icon-home"></i> <span>Dashboard</span></a>
            </li>

            <li class="navLinks nav-link-special"  id="agents" routerLinkActive="active" *ngIf="checkPrivilege(['super_agent'])">
              <a class="has-arrow"><i class="icon-grid"></i> <span>Manage Agents</span></a>
              <ul class="collapse childNavDropDown">
                <li><a (click)="forceReload(null)" [routerLink]="['/user/agents']" routerLinkActive="active">All Agents</a></li>
                <li><a (click)="forceReload(1)" [routerLink]="['/user/agents']" [queryParams]="{status: 'active'}" routerLinkActive="active">Active Agents</a></li>
                <li><a (click)="forceReload(0)" [routerLink]="['/user/agents']" [queryParams]="{status: 'inactive'}" routerLinkActive="active">Inactive Agents</a></li>
              </ul>
            </li>
            <!-- <li class="navLinks nav-link-special"  id="enrol-riders" routerLinkActive="active"  *ngIf="checkPrivilege(['agent'])">
              <a [routerLink]="['/user/enrol-riders']"><i class="icon-action-redo"></i> <span>Enrolment</span></a>
            </li> -->


         <!--   <li class="navLinks nav-link-special"  id="card-issuing" routerLinkActive="active" *ngIf="checkPrivilege(['agent'])">
              <a class="has-arrow"><i class="icon-docs"></i> <span>Card Management</span></a>
              <ul class="collapse childNavDropDown">
                <li><a [routerLink]="['/user/card-management/card-issuing']" routerLinkActive="active">Card Issuing</a></li>
              </ul>
            </li>-->
            <!-- <li class="navLinks nav-link-special"  id="commission-sharing" routerLinkActive="active" *ngIf="checkPrivilege(['super_agent'])"> -->
              <!-- <a [routerLink]="['/user/commission-sharing']"><i class="icon-calculator"></i> <span>Commission</span></a> -->
            <!-- </li> -->
         <!--   <li class="navLinks nav-link-special"  id="integration" routerLinkActive="active" *ngIf="checkPrivilege(['super_agent'])">
              <a [routerLink]="['/user/integration']"><i class="icon-bar-chart"></i> <span>Integrations</span></a>
            </li>-->

            <li class="navLinks nav-link-special"  id="transaction" routerLinkActive="active" *ngIf="checkPrivilege(['agent', 'super_agent'])">
              <a class="has-arrow"><i class="icon-list"></i> <span>Reports</span></a>
              <ul class="collapse childNavDropDown">
                <li><a [routerLink]="['/user/report/transaction']" routerLinkActive="active">Transaction Report</a></li>
                <!-- <li><a [routerLink]="['/user/collection/transaction']" routerLinkActive="active">Transaction Collection</a></li>
                <li><a [routerLink]="['/user/report-agent/transaction']" routerLinkActive="active">Agent Transaction</a></li> -->
              </ul>
            </li>

            <li class="navLinks nav-link-special"  id="settings" routerLinkActive="active">
              <a class="has-arrow"><i class="fa fa-cogs"></i> <span>Settings</span></a>
              <ul class="collapse childNavDropDown">
               <li><a  [routerLink]="['/user/change-password']" routerLinkActive="active">Change Password</a></li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>

      <div class="tab-pane" id="WalletSystem" *ngIf="checkPrivilege(['agent', 'super_agent'])" >
        <h6 class="ml-2">Wallet: <span class="ml-2">{{ wallet || 0 | currency: '&#8358;' }}</span></h6>
        <nav class="sidebar-nav">

        <ul id="main-menu1" class="metismenu">

          <li class="navLinks nav-link-special"  id="wallet-preview" routerLinkActive="active">
            <a [routerLink]="['/user/wallet-history']"><i class="icon-bar-chart"></i> <span>Wallet History</span></a>
          </li>

          <li class="navLinks nav-link-special"  *ngIf="checkPrivilege(['super_agent', 'agent'])"  id="fund-wallet" routerLinkActive="active" (click)="triggerFundWallet()">
            <a [routerLink]="['/user/wallet-history']"><i class="icon-wallet"></i> <span>Fund Wallet</span></a>
          </li>
        </ul>
        </nav>
      </div>
    </div>
  </div>
</div>

<!--Fund Wallet Modal -->
<div class="modal fade" id="fundWallet" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="title" id="defaultModalLabel">Fund Wallet</h4>
      </div>
      <form class="form-auth-small" #fundWalletForm="ngForm" (ngSubmit)="proceedToFund()">

      <div class="modal-body">
        <div class="">
          <div class="form-group">
            <label for="selectPaymentChannel" class="control-label">Select Payment Channel</label>
            <ng-select [items]="paymentChannels" class="ng-select-form" #selectPaymentChannel="ngModel" required id="selectPaymentChannel"
                       [notFoundText]="'No Payment Channel available'"
                       [placeholder]="'Select Payment Channel'"
                       bindLabel="payment_channel"
                       bindValue="id"
                       [multiple]="false"
                       [(ngModel)]="fundWallet.payment_channel_id" [ngModelOptions]="{standalone: true}" >
            </ng-select>
          </div>

          <div class="form-group">
            <label for="amount" class="control-label">Enter Amount(&#8358;)</label>

            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">NGN(&#8358;)</span>
              </div>
              <input type="number" class="form-control" placeholder="Ex: 90999" [disabled]="!fundWallet.payment_channel_id"
                     #amount="ngModel"
                     id="amount" (change)="validateAmount()" (keyup)="validateAmount()"
                     [(ngModel)]="fundWallet.amount" [ngModelOptions]="{standalone: true}" required>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" *ngIf="!loaders.saving" [disabled]="selectPaymentChannel.errors || amount.errors" class="btn btn-primary">Proceed</button>
        <span *ngIf="loaders.saving" class="btn btn-primary">Loading&nbsp;<i class="fa fa-spin fa-spinner"></i></span>
        <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
      </div>

      </form>
    </div>

  </div>
</div>



